import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import settings from '../utilities/settings';
import { BLACK, GRAY_DARK, GRAY_MAIN, GREEN_MAIN } from '../theme/colors';
import { useTranslationContext } from '../hooks/translationsProvider';
import { useTranslation } from 'react-i18next';

const DropDownLanguages: React.FC = () => {
    const {changeLanguage, languages} = useTranslationContext();
    const { t, i18n } = useTranslation();

    return (
        <Box sx={{
            maxWidth:'120px'
        }}>
            <FormControl fullWidth variant="standard"
            sx={{
                "& .MuiInput-underline:after": {
                    borderBottomColor: GREEN_MAIN,
                },
                "& .MuiInput-underline.Mui-focused:after": {
                    borderBottomColor: GREEN_MAIN,
                },
            }}>
                <Select size="small"
                    value={i18n.language}
                    onChange={(event:any) => {
                        changeLanguage(event.target.value)
                    }}
                >
                {languages.map((value, index) => {
                    return (
                        <MenuItem key={value.code} value={value.code} sx={{
                            fontSize:'0.8em',
                            color:BLACK,
                            "&.Mui-selected": {
                                backgroundColor: `${GREEN_MAIN}20 !important`, // 20 is hex for ~12% opacity
                            },
                            "&.Mui-selected:hover": {
                                backgroundColor: `${GREEN_MAIN}30 !important`, // 30 is hex for ~18% opacity
                            },
                        }}>
                            {value.label.toUpperCase()}
                        </MenuItem>
                    )
                })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default DropDownLanguages;
